import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from 'react-redux'
import { cartConstants } from 'services/redux/cart/constants'
import _ from 'lodash'
import { textStyles } from 'styles/text'
import i18n from 'utils/i18n'
import Text from "theme/Text";
import ThemedBlock from 'components/atoms/ThemedBlock'
import Button from 'theme/Button'
import { Contact, ContactField, getPermissionsAsync, requestPermissionsAsync } from 'expo-contacts';
import { Keyboard, Linking, NativeModules, Platform, StyleSheet, View } from 'react-native'
import ThemedLoader from 'components/atoms/ThemedLoader'
import ThemedInputSearch from 'components/atoms/ThemedInputSearch'
import ThemedModal from 'components/atoms/ThemedModal'
import RenderEmployeeList from '../../_functions/EmployeeRenders'
import { employeeConstants } from 'utils/constants/employee-constants'
import Form, { FormLayout } from "components/molecules/Form";
import { FormFieldsConstants } from 'utils/constants/form-constants';
import HelperCart from 'utils/helper-cart'
import HelperString from 'utils/helper-string'
import { colorList } from 'utils/colors'
import ThemedPressable from 'components/atoms/ThemedPressable'
import HelperPlatform from 'utils/helper-platform'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const { RNAndroidOpenSettings } = NativeModules;

const HomeBookSelectCoworkerIndexTabExternal = () => {
	
	const _cartBookingExternalPersons = useSelector( state => {
		return state.cart[cartConstants.BOOKING_EXTERNAL_PERSONS];
	} );
	
	const [ hasContactBookStatus, setHasContactBookStatus ] = useState( false );
	const [ employees, setEmployees ] = useState( [] );
	const [ isLoading, setIsLoading ] = useState( true );
	const [ isPrivacyModalVisible, setIsPrivacyModalVisible ] = useState( false );
	const [ isAddingExternalVisible, setIsAddingExternalVisible ] = useState( false );
	const [ searchValue, setSearchValue ] = useState( '' );
	
	useEffect( () => {
		(async () => {
			const { status } = await getPermissionsAsync();
			setHasContactBookStatus( status === 'granted' );
			
			if( status === 'granted' ) {
				await getContacts();
			}else{
				setIsLoading( false );
			}
		})()
	}, [])
	
	const requestContactBookPermission = () => {
		(async () => {
			const { status } = await requestPermissionsAsync();
			if (status === 'granted') {
				await getContacts();
			}else{
				await Linking.openSettings()
			}
		})();
	}
	
	const getContacts = async () => {
		const contacts = await Contact.getAllDetails([
			ContactField.FULL_NAME,
			ContactField.COMPANY,
			ContactField.EMAILS,
			ContactField.IMAGE,
		]);
		let employees = [];

		_.forEach( contacts, ( contact ) => {
			// currently we required an e-mailaddress (no e-mailaddress = not visible!);
			// multiple e-mailaddresses = multiple results!
			
			if( _.size( contact.emails ) > 0 ) {
				_.forEach( contact.emails, ( contact_email ) => {
					employees.push( {
						guid: contact.id,
						name: contact.fullName,
						company: contact.company,
						email: contact_email.address,
						photo_url: contact.image,
						kind: employeeConstants.KIND_EXTERNAL
					});
				});
			}
		});

		setEmployees( employees );
		setIsLoading( false );
	}
	
	const showPrivacyModal = () =>{
		setIsPrivacyModalVisible( true );
	}
	
	const showAddingExternalModal = () => {
		setIsAddingExternalVisible( true );
	}
	
	const employeeList = useMemo( () => {
		if( _.size( employees ) > 0 ) {
			// When searching copy the list :)
			let employeesFiltered = [ ...employees ];
			if( searchValue.length !== 0 ) {
				employeesFiltered = _.filter( employeesFiltered, o => {
					return _.includes( _.get( o, 'name', '' ).toLowerCase(), searchValue.toLowerCase() ) || ( _.isEmpty( o.company ) === false && _.includes( o?.company?.toLowerCase() ?? '', searchValue?.toLowerCase() ?? '' ) );
				});
			}
			
			return (<>
				<ThemedBlock
					containerStyle={styles.themedBlockMarginTopStackSpaceMarginBottomStackSpace}
					shadow
					smallPadding>
					
					<ThemedInputSearch
						placeholder={ i18n.t( 'page.create.coworker.external.search.input_search') }
						onChangeText={ _.debounce( setSearchValue, 500 ) }
					/>
					
					<Text style={[ styles.smallText, styles.textTextAlignCenter ]}>
						{ i18n.t('page.create.coworker.external.only_email') }
					</Text>
					
					<ThemedPressable
						style={{ flex: undefined, alignItems: 'center', }}
						onPress={ showPrivacyModal }>
						
						<Text
							style={[ styles.smallText, styles.underlineText ]}>
							
							{ i18n.t('page.create.coworker.external.not_stored_on_server') }
						</Text>
					</ThemedPressable>
				</ThemedBlock>
				
				<RenderEmployeeList
					employees={ employeesFiltered }
				/>
			</>);
		}
		
		if( isLoading ) {
			return (
				<View
					style={styles.viewMarginTopStackSpace}>
					
					<ThemedLoader
						text={ i18n.t( 'loading.external_contacts' ) }
					/>
				</View>
			);
		}
		
		return null;
		// _cartBookingExternalPersons is for the 'select' button
	}, [ isLoading, employees, searchValue, _cartBookingExternalPersons ] );
	
	const saveExternalContact = ( values, { callback } = {} ) => {
		let employee = {
			guid: HelperString.random( 20 ),
			name: values.name,
			email: values.email,
			manual: true
		}
		
		HelperCart.toggleExternalContact( employee );
		setIsAddingExternalVisible( false );
	}
	
	const externalModal = useMemo( () => {
		if( !isAddingExternalVisible ) {
			return null;
		}
		
		const formFields = [
			{
				name: 'name',
				label: i18n.t('form.fields.full_name.title'),
				type: FormFieldsConstants.TEXT,
				props: { returnKeyType: 'done', onSubmitEditing: Keyboard.dismiss }
			},
			{
				name: 'email',
				label: i18n.t('form.fields.email.title'),
				type: FormFieldsConstants.TEXT_EMAIL,
				props: { returnKeyType: 'done', onSubmitEditing: Keyboard.dismiss }
			},
		];
		
		return (
			<ThemedModal
				visible={ true }
				title={ i18n.t('page.create.coworker.external.button_add') }
				key={ 'external_contact' }
				setVisible={ setIsAddingExternalVisible }>
				
				<Form
					key={ 'external_contact_form' }
					layout={ FormLayout.VERTICAL }
					values={{}}
					fields={ formFields }
					onSubmit={ saveExternalContact }
				/>
			</ThemedModal>);
	}, [ isAddingExternalVisible ] );
	
	return (
		<View
			style={styles.viewFlex1}>
			
			<VStack
				space={ ThemedValues.stackSpace }>
				
				<ThemedBlock shadow smallPadding>
					<Text
						category={"c1"}
						style={ textStyles.textCenter }>
						
						{ i18n.t('page.create.coworker.external.description') }
					</Text>
				</ThemedBlock>
				
				{ (!hasContactBookStatus && HelperPlatform.isNotWeb()) && (
					<ThemedBlock
						key={"contact_book_permission"}
						shadow
						smallPadding>
						
						<Button
							onPress={ requestContactBookPermission }
							appearance={"outline"}>
							
							{ i18n.t('page.create.coworker.external.button_add_from_phone') }
						</Button>
						
						<ThemedPressable
							style={ { flex: undefined, alignItems: 'center' } }
							onPress={ showPrivacyModal }>
							
							<Text
								category={"c1"}
								style={ styles.italicText }>
								
								{ i18n.t('page.create.coworker.external.not_stored_on_server') }
							</Text>
						</ThemedPressable>
					</ThemedBlock>
				)}
			
				<ThemedBlock
					key={"add_external"}
					shadow
					smallPadding>
					
					<Button
						onPress={ showAddingExternalModal }
						size={"medium"}
						appearance={'outline'}
						style={ styles.buttonWidth200AlignSelfCenter }>
						
						{ i18n.t('page.create.coworker.external.button_add') }
					</Button>
				</ThemedBlock>
			</VStack>
			
			{ employeeList }
			
			{ externalModal }
			
			{ isPrivacyModalVisible && (
				<ThemedModal
					visible={ true }
					title={ i18n.t('page.create.coworker.external.not_stored_on_server') }
					setVisible={ setIsPrivacyModalVisible }>
					
					<View style={ styles.viewMargin8 }>
						<Text style={ styles.textWhiteSpacePreLine }>
							{ i18n.t('page.create.coworker.external.not_stored_on_server_popup') }
						</Text>
					</View>
				</ThemedModal>
			)}
		</View>
	)
}

const Space = () => {
	
	return (
		<View style={styles.viewHeightStackSpace}/>
	)
}

const styles = StyleSheet.create({
	themedBlockMarginTopStackSpaceMarginBottomStackSpace: {
		marginTop: ThemedValues.stackSpace,
		marginBottom: ThemedValues.stackSpace,
	},
	textTextAlignCenter: {
		textAlign: 'center',
	},
	viewMarginTopStackSpace: {
		marginTop: ThemedValues.stackSpace,
	},
	viewFlex1: {
		flex: 1,
	},
	buttonWidth200AlignSelfCenter: {
		width: 200,
		alignSelf: 'center',
	},
	viewMargin8: {
		margin: 8,
	},
	textWhiteSpacePreLine: {
		whiteSpace: 'pre-line',
	},
	viewHeightStackSpace: {
		height: ThemedValues.stackSpace,
	},
	italicText: {
		color: colorList.ORANGE.primary,
		textDecorationLine: 'underline',
		fontStyle: 'italic'
	},
	smallText: {
		fontStyle: 'italic',
		fontSize: 10,
		marginTop: 4
	},
	underlineText: {
		textDecorationLine: 'underline'
	}
})

export default HomeBookSelectCoworkerIndexTabExternal;
